export const VARIANTS = ['RESERVATION_NOT_OK', 'CANCELLATION_NOT_OK']

export const RESERVATION_NOT_OK = 'RESERVATION_NOT_OK'
export const CANCELLATION_NOT_OK = 'CANCELLATION_NOT_OK'
